import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/build/src/components/aspect-ratio.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/layout/banner/banner-client.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/layout/cookie-consent/index.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/layout/cookies/index.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/layout/nav/nav-menu-client.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/reusables/link-trackers.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/reusables/topic-tag.tsx");
import(/* webpackMode: "eager" */ "/build/src/components/ui/aspect-ratio.tsx")